<div class="manual-register-container">
    <h2>{{ inputData.sectionCollumn }}</h2>
    <div class="separator"></div>
    <div class="header-column">
        <div>
            <span>Selecionar Campos</span>
        </div>
        <div>
            <span>Obrigatório*</span>
        </div>
    </div>
    <ul style="padding: 0;">
        <li style="list-style: none;" *ngFor="let item of inputData.fields">
            <div class="container-item">
                <div class="div-checkbox">
                    <label class="container-check">
                        <input type="checkbox" value="{{ item.isEnabled }}" [checked]="item.isEnabled" (change)="changeChecked(item.id, item.isEnabled)">
                        <span class="checkmark"></span>
                    </label>


                    <!-- <input type="checkbox" /> -->
                </div>
                <div class="div-label">
                    {{ item.label }}
                </div>
                <div class="div-slide-toggle">
                    <label class="switch">
                        <input type="checkbox" value="{{ item.isRequired }}" [checked]="item.isRequired" [disabled]="!item.isEnabled" (change)="changeRequired(item.id, item.isEnabled)">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </li>
    </ul>

</div>